import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss?v=2';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { LanguageProvider } from './services/LanguageContext';
import "bootstrap-icons/font/bootstrap-icons.css";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <LanguageProvider>
      <App className='app'/>
    </LanguageProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
